import useCore from '@src/hooks/core/useCore';
import React from 'react';

// moved as a child component to avoid render side effects at app level
const CoreHooks = () => {
  useCore();
  return null;
}

export default React.memo(CoreHooks);
